<!--  -->
<template>
  <div :class="['dictionary', { inApp: $root.$data.isApp }]">
    <common-title
      v-if="!$root.$data.isApp"
      :titleName="pageTile"
      :bcColor="'#FEFEFF'"
      :zIndex="1000"
    ></common-title>
    <!-- banner -->
    <Banner :bannerList="bannerList" />
    <!-- 金刚区域 -->
    <CustomButton :iconLists="iconLists" />
    <!-- 长图广告位 -->
    <Advertisement :advertisement="advertisement" />
    <!-- 活动 -->
    <HomeAdvert v-show="advertLists.length" :advertLists="advertLists" />
    <div class="course-list">
      <div v-for="(item, keys) in courseInfoData" :key="keys" @click="goback()">
        <CombinationCard v-if="item.setType === 1" :key="keys" :item="item" />
        <HotCourseCard v-else :key="keys" :item="item" />
      </div>
    </div>
    <HomePop v-if="isPopBox" @closePopBox="closePopBox" :popupData="popupData" />
  </div>
</template>

<script>
import {
  reqNewTypeList, reqAdvertPlaying, reqMajorAd, reqProducts,
} from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import CommonTitle from '@/components/header/CommonTitle.vue';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import Banner from './components/bannerVant.vue';
import CustomButton from './components/customButton.vue';
import HomeAdvert from './components/homeAdvert.vue';
import HomePop from './components/homePop.vue';
import Advertisement from './components/advertisement.vue';
import {deepCopy} from "@/utils/tools";

export default {
  components: {
    Banner,
    HotCourseCard,
    CombinationCard,
    CommonTitle,
    CustomButton,
    HomeAdvert,
    HomePop,
    Advertisement,
  },
  data() {
    return {
      navList: [],
      bannerList: [],
      courseInfoData: [],
      pageTile: '',
      iconLists: [],
      advertLists: [],
      popupData: {},
      advertisement: {},
      isPopBox: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    goback() {
      sessionStorage.setItem('back', true);
    },
    // 获取分类列表
    async getTypeList() {
      const { type, code } = this.$route.query;
      const res = await reqNewTypeList(type, code);
      if (res.code === 0 && res?.data) {
        const baseList = JSON.parse(res.data.remark);
        const bannerCode = baseList.find((item) => item.key === 'BANNER')?.value;
        const kingkongCode = baseList.find((item) => item.key === 'KINGKONG_AREA')?.value;
        const capsuleCode = baseList.find((item) => item.key === 'CAPSULE_AREA')?.value;
        const advertisementCode = baseList.find((item) => item.key === 'ADVERTISEMENT')?.value;
        const popupCode = baseList.find((item) => item.key === 'POPUP')?.value;
        const recommendId = baseList.find((item) => item.key === 'RECOMMEND_ID')?.value;
        this.pageTile = baseList.find((item) => item.key === 'PAGE_TITLE')?.value;
        document.title = this.pageTile;
        this.getBanner(bannerCode, kingkongCode, capsuleCode, popupCode, advertisementCode);
        this.getCourseAd(recommendId);
      }
    },
    // 请求广告位
    async getBanner(bannerCode, kingkongCode, capsuleCode, advertisementCode, popupCode) {
      const paramsList = [bannerCode, kingkongCode, capsuleCode, advertisementCode, popupCode];
      const res = await reqAdvertPlaying(paramsList);
      if (res.code === 0) {
        // 首页banner
        this.bannerList = res.data?.find(
          (item) => item.adCode === paramsList[0],
        )?.advertisingContentWebInfoRespVOS || [];
        // 请求金刚区
        this.iconLists = res.data?.find(
          (item) => item.adCode === paramsList[1],
        )?.advertisingContentWebInfoRespVOS || [];
        // 请求胶囊区
        this.advertLists = res.data?.find(
          (item) => item.adCode === paramsList[2],
        )?.advertisingContentWebInfoRespVOS || [];
        // 首页弹窗
        this.popupData = res.data?.find(
          (item) => item.adCode === paramsList[3],
        )?.advertisingContentWebInfoRespVOS[0];
        if (this.popupData) {
          if (sessionStorage.getItem('HOME_SECONDARY_PAGE')) {
            this.isPopBox = false;
          } else {
            this.isPopBox = true;
          }
        }
        // 首页长图广告位
        this.advertisement = res.data?.find(
          (item) => item.adCode === paramsList[4],
        )?.advertisingContentWebInfoRespVOS[0];
      }
    },
    // 查询广告位
    async getCourseAd(recommendId) {
      if (!recommendId) return;
      const { code, data } = await reqMajorAd(recommendId);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      }
      this.resetProductData([]);
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = this.resetProductData(res?.data || [], 2);
        const resPackage = this.resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this.courseInfoData = allCourse;
      });
    },
    // 自定义数据格式
    resetProductData(courseList) {
      courseList.forEach((item) => {
        const copyItem = deepCopy(item)
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount
          && productDiscountRespVO?.couponDiscount
          && item.sellPrice > 0
          && !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice)
              + Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return courseList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount
          && item.sellPrice > 0
          && !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    closePopBox() {
      this.isPopBox = false;
      // 存session 控制弹窗
      sessionStorage.setItem('HOME_SECONDARY_PAGE', true);
      this.gioEvent((this.gioType = 2));
    },
  },
  created() {},
  mounted() {
    this.getTypeList();
  },
};
</script>
<style lang="scss" scoped>
.dictionary {
  padding: 136px 0;
  &.inApp {
    padding: 36px 0;
  }
  .course-list {
    padding:15px 36px 36px 36px;
  }
}
</style>
